import { t, d, y, u, G } from "main/jsxRuntime.module";
import { m as membershipService } from "main/membership-service";
var _jsxFileName$1 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/CartDrawerFooter.tsx";
const ALL_ACCESS_VARIANT_ID = "44792925257894";
const ALL_ACCESS_MONTHLY_PLAN = 1574961318;
const ALL_ACCESS_QUARTERLY_PLAN = 1580236966;
const ALL_ACCESS_ANNUALLY_PLAN = 1574994086;
const SUPPORT_MONTHLY_PLAN = 2021261478;
const SUPPORT_QUARTERLY_PLAN = 2080374950;
const SUPPORT_ANNUALLY_PLAN = 2021294246;
const MEDIA_MONTHLY_PLAN = 1575026854;
const MEDIA_QUARTERLY_PLAN = 1580204198;
const MEDIA_ANNUALLY_PLAN = 1575059622;
const MEMBERSHIP_SELLING_PLAN_IDS = [MEDIA_MONTHLY_PLAN, MEDIA_QUARTERLY_PLAN, MEDIA_ANNUALLY_PLAN, ALL_ACCESS_MONTHLY_PLAN, ALL_ACCESS_QUARTERLY_PLAN, ALL_ACCESS_ANNUALLY_PLAN, SUPPORT_MONTHLY_PLAN, SUPPORT_QUARTERLY_PLAN, SUPPORT_ANNUALLY_PLAN];
const AF_QUARTERLY_SELLING_PLAN = ALL_ACCESS_QUARTERLY_PLAN;
const formatMoney = (cents) => {
  return (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
};
const isHighTierMember = (membershipStatus) => {
  return membershipStatus === "not-upgradeable";
};
const hasMembershipInCart = (cart) => {
  return cart.items.some((item) => {
    var _a;
    return ((_a = item.selling_plan_allocation) == null ? void 0 : _a.selling_plan.id) && MEMBERSHIP_SELLING_PLAN_IDS.includes(item.selling_plan_allocation.selling_plan.id);
  });
};
const hasSubscriptionProductInCart = (cart) => {
  return cart.items.some((item) => {
    var _a;
    return ((_a = item.selling_plan_allocation) == null ? void 0 : _a.selling_plan.id) && MEMBERSHIP_SELLING_PLAN_IDS.includes(item.selling_plan_allocation.selling_plan.id) && item.selling_plan_allocation;
  });
};
const calculateNonMembershipTotal = (cart) => {
  return cart.items.filter((item) => {
    var _a;
    return !((_a = item.selling_plan_allocation) == null ? void 0 : _a.selling_plan.id) || !MEMBERSHIP_SELLING_PLAN_IDS.includes(item.selling_plan_allocation.selling_plan.id);
  }).reduce((total, item) => {
    console.log({
      item
    });
    const lineitemPrice = item.original_price === item.price ? item.price : item.price < item.final_price ? item.price : item.final_price;
    return total + lineitemPrice * item.quantity;
  }, 0);
};
const calculateMembershipTotal = (cart) => {
  return cart.items.filter((item) => {
    var _a;
    return !((_a = item.selling_plan_allocation) == null ? void 0 : _a.selling_plan.id) || !MEMBERSHIP_SELLING_PLAN_IDS.includes(item.selling_plan_allocation.selling_plan.id);
  }).reduce((total, item) => {
    console.log({
      item
    });
    const lineitemPrice = item.price < item.final_price ? item.price : item.final_price;
    return total + lineitemPrice * item.quantity;
  }, 0);
};
const calculateMemberPrice = (cart) => {
  const nonMembershipTotal = calculateMembershipTotal(cart);
  return Math.round(nonMembershipTotal * 0.7);
};
const getMembershipLineItem = (cart) => {
  return cart.items.find((item) => {
    var _a;
    return ((_a = item.selling_plan_allocation) == null ? void 0 : _a.selling_plan.id) && MEMBERSHIP_SELLING_PLAN_IDS.includes(item.selling_plan_allocation.selling_plan.id);
  }) || null;
};
const updateFreeShippingProgress = (cartTotalPrice) => {
  const freeShippingElements = document.querySelectorAll("[data-free-shipping]");
  freeShippingElements.forEach((element) => {
    const limitAttribute = element.getAttribute("data-free-shipping-limit");
    if (!limitAttribute) return;
    const freeShippingLimit = parseFloat(limitAttribute) * 100;
    const subtotal = cartTotalPrice;
    const percentValue = isNaN(subtotal / freeShippingLimit) ? 100 : subtotal / freeShippingLimit;
    const percent = Math.min(percentValue * 100, 100);
    const progressBar = element.querySelector(".free-shipping__progress-fill");
    if (progressBar) {
      progressBar.style.width = `${percent}%`;
    }
    const leftToSpendElement = element.querySelector("[data-left-to-spend]");
    if (leftToSpendElement) {
      const leftToSpend = Math.max(freeShippingLimit - subtotal, 0);
      const formattedAmount = (leftToSpend / 100).toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
      });
      leftToSpendElement.textContent = formattedAmount;
    }
  });
};
function CartDrawerFooter({
  "class": className = ""
}) {
  var _a;
  const [cart, setCart] = t(d(null), "cart");
  const [membershipStatus, setMembershipStatus] = t(d("not-member"), "membershipStatus");
  const [isUsingMemberPrice, setIsUsingMemberPrice] = t(d(false), "isUsingMemberPrice");
  const [isLoading, setIsLoading] = t(d(false), "isLoading");
  const fetchCart = async () => {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) {
        throw new Error(`Cart fetch failed: ${response.status}`);
      }
      const cartData = await response.json();
      if (!cartData || !Array.isArray(cartData.items)) {
        console.warn("Invalid cart data structure:", cartData);
        setCart(null);
        return;
      }
      setCart(cartData);
      const cartTotalElement = document.querySelector("[data-cart-total]");
      if (cartTotalElement) {
        cartTotalElement.setAttribute("data-cart-total", cartData.total_price.toString());
        cartTotalElement.textContent = cartData.total_price.toString();
      }
      updateFreeShippingProgress(cartData.total_price);
      const hasMembership = hasMembershipInCart(cartData);
      setIsUsingMemberPrice(hasMembership);
    } catch (error) {
      console.error("CartDrawerFooter: Error fetching cart:", error);
      setCart(null);
    }
  };
  const fetchMembershipStatus = async () => {
    try {
      const result = await membershipService.getCurrentMembershipStatus();
      setMembershipStatus(result.status);
    } catch (error) {
      console.error("Error fetching membership status:", error);
      setMembershipStatus("not-member");
    }
  };
  y(() => {
    fetchCart();
    fetchMembershipStatus();
    const handleCartRefresh = (event) => {
      fetchCart();
    };
    document.addEventListener("theme:cart:refresh", handleCartRefresh);
    document.addEventListener("theme:cart:change", handleCartRefresh);
    window.addEventListener("cart:updated", handleCartRefresh);
    return () => {
      document.removeEventListener("theme:cart:refresh", handleCartRefresh);
      document.removeEventListener("theme:cart:change", handleCartRefresh);
      window.removeEventListener("cart:updated", handleCartRefresh);
    };
  }, []);
  const handleRemoveSubscriptionProducts = async () => {
    var _a2, _b;
    if (!cart) return;
    setIsLoading(true);
    try {
      const subscriptionItems = cart.items.filter((item) => {
        var _a3;
        return ((_a3 = item.selling_plan_allocation) == null ? void 0 : _a3.selling_plan.id) && MEMBERSHIP_SELLING_PLAN_IDS.includes(item.selling_plan_allocation.selling_plan.id);
      });
      for (const item of subscriptionItems) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: item.variant_id,
            quantity: 0
          })
        });
      }
      if ((_b = (_a2 = window.Shopify) == null ? void 0 : _a2.cart) == null ? void 0 : _b.refreshCart) {
        window.Shopify.cart.refreshCart();
      } else {
        document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
          bubbles: true
        }));
      }
    } catch (error) {
      console.error("Error removing subscription products:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleAddMembershipProduct = async () => {
    var _a2, _b;
    setIsLoading(true);
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [{
            id: ALL_ACCESS_VARIANT_ID,
            quantity: 1,
            selling_plan: AF_QUARTERLY_SELLING_PLAN
          }]
        })
      });
      if (response.ok) {
        if ((_b = (_a2 = window.Shopify) == null ? void 0 : _a2.cart) == null ? void 0 : _b.refreshCart) {
          window.Shopify.cart.refreshCart();
        } else {
          document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
            bubbles: true
          }));
        }
      } else {
        console.error("Failed to add membership product");
      }
    } catch (error) {
      console.error("Error adding membership product:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleRegularPriceClick = () => {
    if (!cart) return;
    if (isHighTierMember(membershipStatus) || hasMembershipInCart(cart)) {
      return;
    }
    if (hasSubscriptionProductInCart(cart)) {
      handleRemoveSubscriptionProducts();
    }
    setIsUsingMemberPrice(false);
  };
  const handleMemberPriceClick = () => {
    if (!isUsingMemberPrice) {
      handleAddMembershipProduct();
    }
    setIsUsingMemberPrice(true);
  };
  if (!cart) {
    return u("div", {
      className: `cart-drawer-footer rs-border-t rs-border-moss ${className}`,
      children: [u("div", {
        className: "rs-border-b rs-border-black rs-mb-2.5",
        children: [u("div", {
          className: "rs-flex rs-items-center rs-justify-between rs-py-2 rs-border-b",
          children: [u("div", {
            className: "rs-flex rs-items-center rs-gap-3",
            children: [u("div", {
              className: "rs-w-6 rs-h-6 rs-border-2 rs-border-gray-300 rs-rounded-full rs-animate-pulse"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 341,
              columnNumber: 15
            }, this), u("div", {
              className: "rs-bg-gray-200 rs-h-4 rs-w-24 rs-rounded rs-animate-pulse"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 342,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1,
            lineNumber: 340,
            columnNumber: 13
          }, this), u("div", {
            className: "rs-bg-gray-200 rs-h-4 rs-w-16 rs-rounded rs-animate-pulse"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 344,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 339,
          columnNumber: 11
        }, this), u("div", {
          className: "rs-flex rs-items-center rs-justify-between rs-py-2",
          children: [u("div", {
            className: "rs-flex rs-items-center rs-gap-3",
            children: [u("div", {
              className: "rs-w-6 rs-h-6 rs-border-2 rs-border-gray-300 rs-rounded-full rs-animate-pulse"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 350,
              columnNumber: 15
            }, this), u("div", {
              className: "rs-bg-gray-200 rs-h-6 rs-w-28 rs-rounded-md rs-animate-pulse"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 351,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$1,
            lineNumber: 349,
            columnNumber: 13
          }, this), u("div", {
            className: "rs-bg-gray-200 rs-h-4 rs-w-16 rs-rounded rs-animate-pulse"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 353,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 348,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 337,
        columnNumber: 9
      }, this), u("div", {
        className: "rs-flex rs-justify-between rs-items-center rs-py-2 rs-border-b rs-border-black rs-border-opacity-80 rs-mb-2",
        children: [u("div", {
          className: "rs-bg-gray-200 rs-h-4 rs-w-32 rs-rounded rs-animate-pulse"
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 359,
          columnNumber: 11
        }, this), u("div", {
          className: "rs-bg-gray-200 rs-h-4 rs-w-16 rs-rounded rs-animate-pulse"
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 360,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 358,
        columnNumber: 9
      }, this), u("div", {
        className: "rs-flex rs-justify-between rs-items-center rs-mb-4",
        children: [u("div", {
          className: "rs-bg-gray-200 rs-h-4 rs-w-16 rs-rounded rs-animate-pulse"
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 365,
          columnNumber: 11
        }, this), u("div", {
          className: "rs-bg-gray-200 rs-h-4 rs-w-20 rs-rounded rs-animate-pulse"
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 366,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 364,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1,
      lineNumber: 335,
      columnNumber: 7
    }, this);
  }
  const nonMembershipTotal = calculateNonMembershipTotal(cart);
  const memberPrice = calculateMemberPrice(cart);
  const membershipLineItem = getMembershipLineItem(cart);
  const isRegularPriceDisabled = isHighTierMember(membershipStatus) || hasMembershipInCart(cart);
  return u("div", {
    className: `cart-drawer-footer rs-border-t rs-border-moss ${className}`,
    children: [u("div", {
      className: "rs-border-b rs-border-black rs-mb-2.5",
      children: [u("div", {
        className: `rs-flex rs-items-center rs-justify-between rs-py-2 rs-cursor-pointer rs-border-b ${isRegularPriceDisabled ? "rs-opacity-60 rs-cursor-not-allowed" : ""}`,
        onClick: !isRegularPriceDisabled ? handleRegularPriceClick : void 0,
        children: [u("div", {
          className: "rs-flex rs-items-center rs-gap-3",
          children: [u("div", {
            className: "rs-w-6 rs-h-6 rs-border-2 rs-border-black rs-rounded-full rs-flex rs-items-center rs-justify-center",
            children: !isUsingMemberPrice && !isRegularPriceDisabled && u("div", {
              className: "rs-w-3 rs-h-3 rs-bg-black rs-rounded-full"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 392,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 390,
            columnNumber: 13
          }, this), u("span", {
            className: `rs-text-base rs-leading-4 rs-text-black ${isRegularPriceDisabled ? "rs-opacity-60" : ""}`,
            children: "Regular Price"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 395,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 389,
          columnNumber: 11
        }, this), u("span", {
          className: `rs-text-base rs-text-black ${isRegularPriceDisabled ? "rs-opacity-60" : ""}`,
          children: formatMoney(nonMembershipTotal)
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 399,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 383,
        columnNumber: 9
      }, this), u("div", {
        className: "rs-flex rs-items-center rs-justify-between rs-py-2 rs-cursor-pointer",
        onClick: handleMemberPriceClick,
        children: [u("div", {
          className: "rs-flex rs-items-center rs-gap-3",
          children: [u("div", {
            className: "rs-w-6 rs-h-6 rs-border-2 rs-border-black rs-rounded-full rs-flex rs-items-center rs-justify-center",
            children: (isUsingMemberPrice || isRegularPriceDisabled) && u("div", {
              className: "rs-w-3 rs-h-3 rs-bg-black rs-rounded-full"
            }, void 0, false, {
              fileName: _jsxFileName$1,
              lineNumber: 412,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 410,
            columnNumber: 13
          }, this), u("div", {
            className: "rs-bg-grass rs-px-1 rs-py-1.5 rs-rounded-md rs-text-base rs-text-black rs-font-bold rs-leading-4",
            children: "Member Price"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 415,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 409,
          columnNumber: 11
        }, this), u("span", {
          className: "rs-text-base rs-text-black",
          children: formatMoney(memberPrice)
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 419,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 405,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1,
      lineNumber: 381,
      columnNumber: 7
    }, this), membershipLineItem && u("div", {
      className: "rs-flex rs-justify-between rs-items-center rs-py-2 rs-border-b rs-border-black rs-border-opacity-80 rs-mb-2",
      children: [u("div", {
        className: "rs-text-base rs-text-black",
        children: [u("span", {
          className: "rs-font-bold",
          children: "Membership"
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 427,
          columnNumber: 13
        }, this), ((_a = membershipLineItem.selling_plan_allocation) == null ? void 0 : _a.selling_plan.name) && u("span", {
          className: "rs-ml-1",
          children: ["(", membershipLineItem.selling_plan_allocation.selling_plan.name, ")"]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 429,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$1,
        lineNumber: 426,
        columnNumber: 11
      }, this), u("div", {
        className: "rs-text-base rs-text-black",
        children: formatMoney(membershipLineItem.final_price)
      }, void 0, false, {
        fileName: _jsxFileName$1,
        lineNumber: 432,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1,
      lineNumber: 425,
      columnNumber: 9
    }, this), membershipLineItem && u("div", {
      className: "rs-flex rs-justify-between rs-items-center rs-mb-4",
      children: [u("span", {
        className: "rs-text-base rs-text-black",
        children: "Subtotal"
      }, void 0, false, {
        fileName: _jsxFileName$1,
        lineNumber: 441,
        columnNumber: 11
      }, this), u("span", {
        className: "rs-text-base rs-text-black",
        children: formatMoney(cart.total_price)
      }, void 0, false, {
        fileName: _jsxFileName$1,
        lineNumber: 442,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1,
      lineNumber: 440,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1,
    lineNumber: 379,
    columnNumber: 5
  }, this);
}
var _jsxFileName = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/entrypoints/cart-drawer-footer.tsx";
class CartDrawerFooterElement extends HTMLElement {
  constructor() {
    super(...arguments);
    this.initialized = false;
  }
  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      G(u(CartDrawerFooter, {}, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 14
      }, this), this);
    }
  }
  disconnectedCallback() {
    this.initialized = false;
    G(null, this);
  }
}
customElements.define("cart-drawer-footer", CartDrawerFooterElement);
